import { Account, FaqItemType } from './models/account';
import { Channel, ChannelGroup, Epg } from './models/tv';
import * as AccountProvider from './providers/account_provider';
import * as CinemaProvider from './providers/cinema_provider';
import * as TvProvider from './providers/tv_provider';

export { AccountProvider, CinemaProvider, TvProvider };
export type { Account, Channel, ChannelGroup, Epg, FaqItemType };
